/** Operator-facing supported-scope SLA. Parser ids must match packages/scanner/src/supported-scope.ts. */
export const SUPPORTED_SCOPE_ID = "assure-supported-scope/v1.2";

export const SUPPORTED_SCOPE_SUMMARY =
  "This console reviews authorized synthetic source, or an allowlisted public benchmark, without executing it. It does not claim ISO-complete language coverage, live vulnerability feeds, or a clean result from an empty queue.";

export const SUPPORTED_LANGUAGES = [
  { id: "JavaScript", parser: "Babel", note: "Production parser." },
  { id: "TypeScript", parser: "Babel", note: "Production parser." },
  {
    id: "Python",
    parser: "python-tree-sitter-v1",
    note: "Tree-sitter grammar. ERROR nodes fail the SAST cell, not clean.",
  },
  {
    id: "Go",
    parser: "go-tree-sitter-v1",
    note: "Tree-sitter grammar. ERROR nodes fail the SAST cell, not clean.",
  },
  {
    id: "Java",
    parser: "java-tree-sitter-v1",
    note: "Tree-sitter grammar. ERROR nodes fail the SAST cell, not clean.",
  },
  {
    id: "C#",
    parser: "csharp-tree-sitter-v1",
    note: "Tree-sitter grammar. ERROR nodes fail the SAST cell, not clean.",
  },
] as const;

export const SUPPORTED_FRAMEWORKS = [
  "Express",
  "Flask",
  "Django",
  "net/http",
  "Servlet",
  "ASP.NET",
  "Spring",
] as const;

export const OPERATOR_TRUTH_RULES = [
  {
    id: "empty-is-not-clean",
    title: "An empty finding list is not a clean scan",
    body: "If nothing is in the queue, open Evidence. Only reviewed cells with a denominator can support “nothing to decide.”",
  },
  {
    id: "confirmed-needs-replay",
    title: "Confirmed is not proven without replay",
    body: "A confirmed label is trustworthy only when the cited range still matches the frozen snapshot. Mismatch or unavailable replay cannot support a clean confirmation.",
  },
  {
    id: "pending-decisions",
    title: "The queue counts work that still needs a decision",
    body: "Needs-human is for unmapped weaknesses, missing confirmation signals, or leftover non-generic assumptions. Confirmed means source-consistent replay, not a proven exploit. Refuted and suppressed rows already have a decision.",
  },
  {
    id: "reviewed-only-clean",
    title: "Reviewed is the only clean-looking coverage state",
    body: "Failed, blocked, unsupported, excluded, stale, unavailable, and mixed leftover stay visible. They are never shown as clean.",
  },
  {
    id: "model-advisory",
    title: "Model answers are advisory",
    body: "The investigation helper cannot confirm, refute, suppress, change severity, or write the repository. Unconfigured providers stay visible as unavailable, not hidden.",
  },
] as const;

export const OUT_OF_SCOPE = [
  "Live NVD/OSV freshness",
  "Dynamic exploit validation",
  "GitHub writeback",
  "Customer or production data",
  "ISO-complete Python, Go, Java, or C# grammars",
  "Unpinned or missing external engines treated as a clean run",
] as const;
